import kpuRoles from '@/app/bsg/kpu/roles.js'

export default [
  {
    path: '/bsg/kpu',
    name: 'BSG-kpu',
    component: () => import('@/app/bsg/kpu/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', active: true, i18n: 'KPU.MainTitle' }
      ],
      pageTitle: 'KPUs',
      i18n: 'KPU.MainTitle',
      requireAuth: true,
      requireRoles: kpuRoles.readers
    }
  },
  {
    path: '/bsg/kpu/kpus',
    name: 'BSG-kpu-kpus',
    component: () => import('@/app/bsg/kpu/kpus.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'KPUs', active: true, i18n: 'KPU.Title' }
      ],
      pageTitle: 'KPUs',
      i18n: 'KPU.Title',
      requireAuth: true,
      requireRoles: kpuRoles.readers
    }
  },
  {
    path: '/bsg/kpu/edit',
    name: 'BSG-kpu-kpu-edit',
    component: () => import('@/app/bsg/kpu/edit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'KPUs', url: '/bsg/kpu/kpus',  i18n: 'KPU.Title' },
        { title: 'Edit', active: true, i18n: 'KPU.Edit' }
      ],
      pageTitle: 'KPUEdit',
      i18n: 'KPU.Edit',
      requireAuth: true,
      requireRoles: kpuRoles.collaborators
    }
  },
  {
    path: '/bsg/kpu/admin',
    name: 'BSG-kpu-admin',
    component: () => import('@/app/bsg/kpu/admin/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Admin', active: true,  i18n: 'KPU.Admin.Title' }
      ],
      pageTitle: 'Admin',
      i18n: 'KPU.Admin.Title',
      requireAuth: true,
      requireRoles: kpuRoles.admins
    }
  },
  {
    path: '/bsg/kpu/admin/keyprojects',
    name: 'BSG-kpu-admin-keyprojects',
    component: () => import('@/app/bsg/kpu/admin/KeyProjects.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Admin', url: '/bsg/kpu/admin',  i18n: 'KPU.Admin.Title' },
        { title: 'KeyProjects', active: true, i18n: 'KPU.KeyProject.Title' }
      ],
      pageTitle: 'KeyProjects',
      i18n: 'KPU.KeyProject.Title',
      requireAuth: true,
      requireRoles: kpuRoles.admins
    }
  },
  {
    path: '/bsg/kpu/admin/keyprojecttypes',
    name: 'BSG-kpu-admin-keyprojecttypes',
    component: () => import('@/app/bsg/kpu/admin/KeyProjectTypes.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Admin', url: '/bsg/kpu/admin',  i18n: 'KPU.Admin.Title' },
        { title: 'KeyProjectTypes', active: true, i18n: 'KPU.KeyProjectType.Title' }
      ],
      pageTitle: 'KeyProjectTypes',
      i18n: 'KPU.KeyProjectType.Title',
      requireAuth: true,
      requireRoles: kpuRoles.admins
    }
  },
  {
    path: '/bsg/kpu/report/kpu',
    name: 'BSG-kpu-report',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'CashFlowGroupId',
      reportId: 'BusinessStrategyKpu'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Report', active: true, i18n: 'KPU.Report' }
      ],
      requireAuth: true,
      requireRoles: kpuRoles.readers,
      pageTitle: 'KPU Report',
      i18n: 'KPU.Report'     
    }
  },
  {
    path: '/bsg/kpu/report/paginatedkpu',
    name: 'BSG-kpu-paginatedreport',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'CashFlowGroupId',
      reportId: 'BusinessStrategyKpuPaginated'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Report', active: true, i18n: 'KPU.PaginatedReport' }
      ],
      requireAuth: true,
      requireRoles: kpuRoles.admins,
      pageTitle: 'KPU PaginatedReport',
      i18n: 'KPU.PaginatedReport'     
    }
  },
  {
    path: '/bsg/kpu/report/paginatedkpu',
    name: 'BSG-kpu-paginatedreport-single',
    component: () => import('@/app/bsg/kpu/reports/keyProject.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'KPUs', url: '/bsg/kpu',  i18n: 'KPU.MainTitle' },
        { title: 'Report', active: true, i18n: 'KPU.PaginatedReport' }
      ],
      requireAuth: true,
      requireRoles: kpuRoles.readers,
      pageTitle: 'KPU PaginatedReport',
      i18n: 'KPU.PaginatedReport'     
    }
  }
]